export enum GenericCountdownSourceEnum {
    counteroffer,
    lastOfferEventMsg,
    liveOfferAcceptCountdown,
}
